export default __webpack_public_path__ + "static/media/88.9a113bfa.svg";